export enum ApplicationBundleStatus {
  SENT = 'Sent',
  IN_PROGRESS = 'In Progress',
  SUBMITTED = 'Submitted',
  /** The owner reviewed the submission and asked for more information; the bundle is editable again until resubmitted. */
  UPDATE_REQUESTED = 'Update Requested',
  ACCEPTED = 'Accepted',
  DECLINED = 'Declined',
}
